import { useRecoilValue } from "recoil";
import { currentStationState } from "../recoilState";
import createTwitterLink from "../utils/createTwitterLink";

export default function useTweetStation() {
  const currentStation = useRecoilValue(currentStationState);
  function tweetStation() {
    if (currentStation) {
      window.open(
        createTwitterLink({
          text: `Chilling with 🎧 ${currentStation.name}`,
          url: `https://lofi.cafe/?station=${currentStation.id}`,
        })
      );
    }
  }
  return tweetStation;
}
